
import { Component, OnInit, KeyValueDiffers, KeyValueDiffer, ViewChild, Input } from '@angular/core';
import { AuthService } from 'src/app/authentication/auth.service';
import { TipologiaUtente } from 'src/app/model/utente/utente';
import { PageContainerComponent } from 'src/app/shared/interfaces/PageContainerComponent';
import { AppUtilsService } from 'src/app/shared/services/app-utils.service';
import { DocumentsComponent } from 'src/app/shared/components/documents/documents.component';
import { NotificheService } from 'src/app/services/notifiche/notifiche.service';
import { TranslateService } from '@ngx-translate/core';
import {NotificationToastService} from '../../../services/notification-toast/notification-toast.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent extends PageContainerComponent implements OnInit {
  docFirst: number = 0;
  docLength: number = 4;
  uploadDisabled = false;
  firstTime = true;
  differ: KeyValueDiffer<string, any>;
  @ViewChild(DocumentsComponent) child;
  @Input() message: string
  constructor(
    protected appUtils: AppUtilsService,
    private differs: KeyValueDiffers,
    private authServ: AuthService,
    protected snackBar: NotificationToastService,
    private notificheServ: NotificheService,
    private translate: TranslateService,
    private breadcrumbService:BreadcrumbService

  ) {
    super(appUtils, snackBar);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit(): void {

    this.checkTeamView();
    this.utenteLoggato = this.authServ.getUtenteLoggato();
    this.uploadDisabled = this.isTeamView || (!!this.utenteLoggato && this.utenteLoggato.tipologiaUtente == TipologiaUtente.PIAMAT);
    if (this.firstTime) {
      this.notificheServ.setResetTimer(true)
    }
    this.getNumberNotification()
    this.breadcrumbService.clear();
  }
   ngOnChanges(){
  }
  getNumberNotification(){

    this.notificheServ.getNumberNotification().subscribe(res => {

      if (this.firstTime) {
        this.firstTime = false;
        let key;

        if (res > 1) {
          key = "numberNotifications"
        } else if(res === 0) {
          key = "noNotifications"
        } else {
          key = "numberNotification"
        }

        this.translate.get(key, { number: res }).subscribe(message => {
          this.message = message
        });
      } else if (res !== 0) {
        let key = res > 1 || res === 0 ? "numberNotifications" : "numberNotification"
        this.translate.get(key, { number: res }).subscribe(message => {
          this.message = message
        });
      }

    })

  }

  ngOnDestroy() {
    this.unsubscribeOnDestroy();
  }

  unsubscribeOnDestroy() {
    this.obsIsTeamView.unsubscribe()
  }

  onViewChange() {

  }

  ngDoCheck() {
    const change = this.differ.diff(this);
    if (change) {
      change.forEachChangedItem(item => {
        if (item.key === 'isTeamView') {
          this.uploadDisabled = this.isTeamView || (!!this.utenteLoggato && this.utenteLoggato.tipologiaUtente == TipologiaUtente.PIAMAT);
        }
      });
    }
  }

  updateDocuments() {
    this.child.ngOnInit()
  }

}
